import React, { useCallback } from 'react';
import moment from 'moment/moment';
import { EditIcon, TrashIcon } from 'components/icons';
import IconButton from 'components/shared/IconButton';
import styles from './DeviceChartMarkerPopupItem.module.css';

function DeviceChartMarkerPopupItem({ marker, onEdit, onDelete, index }) {
  const editable = !marker.id.startsWith('reboot');
  const handleDelete = useCallback(() => {
    onDelete(marker);
  }, [onDelete, marker]);
  const handleEdit = useCallback(() => {
    onEdit(marker);
  }, [onEdit, marker]);

  return (
    <div className={styles.root} tabIndex={index && -1}>
      <div className={styles.title}>{marker.label}</div>
      <div className={styles.content}>
        <div className={styles.timestamp}>{moment(marker.value).format('MMM D, YYYY, hh:mm a')}</div>
        {editable && (
          <div className={styles.actions}>
            <IconButton aria-label="Edit" variant="text" color="primary" size="x-small" onClick={handleEdit}>
              <EditIcon />
            </IconButton>
            <IconButton aria-label="Delete" variant="text" color="primary" size="x-small" onClick={handleDelete}>
              <TrashIcon />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
}

export { DeviceChartMarkerPopupItem };
